import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  rightPanel: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 20
  }
})

export default useStyles
